import { Mail, Phone } from "lucide-react";
import Reveal from "../components/Reveal";
import { trackEmailClick, trackPhoneClick } from "../lib/analytics";

const EXPECTATIONS = [
    "Review your hiring goals and target markets",
    "Outline suitable EOR options in the US and Canada",
    "Explain how the process works, step by step",
    "Discuss our related legal and tax services",
    "Answer your questions with no obligation",
];

export default function ContactSection() {
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="grain relative overflow-hidden bg-navy py-24 lg:py-32"
        >
            <div className="dot-grid absolute inset-0" aria-hidden="true" />
            <div
                className="absolute -right-32 -top-32 h-[420px] w-[420px] rounded-full bg-royal/25 blur-[130px]"
                aria-hidden="true"
            />
            <div className="relative mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:items-center">
                <div className="lg:col-span-7">
                    <Reveal>
                        <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.28em] text-gold">
                            <span className="h-px w-10 bg-gold/70" aria-hidden="true" />
                            Get In Touch
                        </p>
                        <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
                            Speak with our EOR team
                        </h2>
                        <p className="mt-6 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">
                            The fastest way to get answers is a direct
                            conversation. Call our team to discuss your hiring
                            goals, the markets you are considering, and whether
                            an employer of record arrangement fits your
                            business. No forms, no obligation — just a
                            conversation.
                        </p>
                    </Reveal>

                    <Reveal delay={0.1}>
                        <div className="mt-10 flex flex-wrap items-center gap-4">
                            <a
                                href="tel:+18333439367"
                                data-testid="contact-call-cta"
                                onClick={() => trackPhoneClick("contact")}
                                className="inline-flex items-center gap-3 rounded-full bg-gold px-8 py-4 font-display text-base font-extrabold tracking-wide text-navy transition-[background-color,transform] duration-200 hover:bg-[#b8985a] hover:scale-[1.03]"
                            >
                                <Phone size={18} strokeWidth={2.5} aria-hidden="true" />
                                Call +1 833-343-9367
                            </a>
                            <a
                                href="mailto:info@hexagoneor.com"
                                data-testid="contact-email-cta"
                                onClick={() => trackEmailClick("contact")}
                                className="inline-flex items-center gap-3 rounded-full border border-white/25 px-8 py-4 font-display text-sm font-bold tracking-wide text-white transition-[background-color,border-color] duration-200 hover:border-white/50 hover:bg-white/5"
                            >
                                <Mail size={16} aria-hidden="true" />
                                info@hexagoneor.com
                            </a>
                        </div>
                        <p className="mt-6 text-sm text-white/50">
                            Primary market: United States · Secondary market:
                            Canada
                        </p>
                    </Reveal>
                </div>

                <Reveal delay={0.15} className="lg:col-span-5">
                    <div
                        data-testid="contact-expectations-card"
                        className="rounded-2xl border border-white/10 bg-white/5 p-8 backdrop-blur-md lg:p-10"
                    >
                        <h3 className="font-display text-lg font-bold tracking-tight text-white">
                            On the call, we can:
                        </h3>
                        <ul className="mt-6 space-y-4">
                            {EXPECTATIONS.map((item) => (
                                <li
                                    key={item}
                                    className="flex items-start gap-3 text-sm leading-relaxed text-white/75"
                                >
                                    <svg
                                        width="9"
                                        height="9"
                                        viewBox="0 0 10 10"
                                        className="mt-1.5 shrink-0"
                                        aria-hidden="true"
                                    >
                                        <path d="M5 0 10 5 5 10 0 5Z" fill="#C8A96B" />
                                    </svg>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
